/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2024-02-04 11:34:24
 * @FilePath: \frontend\src\utils\const.js
 */
import { i18n } from '@/Lang';

export const devType = {
  tempHumSensorType: '01',
  tempx3SensorType: '07',
  vibrationSensorType: '09',
  currentPulseSensorType: '10',
  ctSensorType: '12',
  voltagePulseSensorType: '13',
  vsnSensorType: '18',
  currentPulseX3SensorType: '1B',
  voltagePulseX3SensorType: '1C',
  dryContactPulseSensorType: '1D',
  AiCameraSensorType: '29',
  rwmUnit: '2C',
  tev: '2D',
  vdn2Sensor: '2B',
  vb2TFSensorType: '2F',
  valvePositionSensor: '35',
  repeat: 'FE',
  unknown: 'Unknown',
};

/*
export const gwDevType = {
  unknown: 'Unknown',
  testDevType: 'TestDevType',
};
*/

export const chartType = {
  lineChart: '01',
  scatterChart: '02',
  histogramChart: '03',
  table: '04',
  notes: '05',
  gauge: '06',
  numeric: '07',
  timeLine: '08',
  heatMap: '09',
};

export const wlanOptionConst = {
  disabled: 0,
  station: 1,
  ap: 3,
};

export const chartTypeMap = new Map([
  ['01', 'LineChart'],
  ['02', 'ScatterChart'],
  ['03', 'HistogramChart'],
  ['04', 'Table'],
  ['05', 'Notes'],
  ['06', 'Gauge'],
  ['07', 'Numeric'],
  ['08', 'TimeLine'],
  ['09', 'HeatMap'],
]);

// export const userCfgType = {
//   dashboardUserCfg: 1,
//   mapUserCfg: 2,
//   deviceTableSettingCfg: 3,
//   gatewayTableSettingCfg: 4,
//   deviceListSetting: 5,
//   gatewayListSetting: 6,
//   deviceColsWidthSettingCfg: 7,
//   gatewayColsWidthSettingCfg: 8,
// };

export const userCfgType = {
  dashboardUserCfg: 'dashboardUserCfg',
  mapUserCfg: 'mapUserCfg',
  deviceTableSettingCfg: 'deviceTableSettingCfg',
  gatewayTableSettingCfg: 'gatewayTableSettingCfg',
  deviceListSetting: 'deviceListSetting',
  gatewayListSetting: 'gatewayListSetting',
  deviceColsWidthSettingCfg: 'deviceColsWidthSettingCfg',
  gatewayColsWidthSettingCfg: 'gatewayColsWidthSettingCfg',
};

// export const sysCfgType = {
//   subgKey: '1',
//   subgCfg: '2',
//   subGwCfg: '3',
//   subgDevId: '4',
//   mapSensorPop: '5',
//   gateWayInfo: '6',
//   sliderBarInfo: '7',
//   gwName: '8',
//   notification: '9',
// };

export const sysCfgType = {
  subgCfg: 'subgCfg',
  // subgDevId: 'subgDevId',
  mapSensorPop: 'mapSensorPop',
  gateWayInfo: 'gateWayInfo',
  sliderBarInfo: 'sliderBarInfo',
  // notification: 'notification',
  mapImageKey: 'mapImageKey',
};

export const dataType = {
  DEV_KEY: 'devKey',
  DEV_ID: 'dev_id',
  DEV_TYPE: 'devType',
  DEV_Status: 'devStatus',
  DEV_DelFlag: 'deleteFlag',
  BAT_Volt: 'batteryVoltage',
  GROUP1: 'group1',
  GROUP2: 'group2',
  GROUP3: 'group3',
  RSSI: 'rssi',
  TIMESTAMP: 'timestamp',
  CP_Ct: 'current',
  AC_Inference: 'inference',
  CT_Ct1: 'current1',
  CT_Ct2: 'current2',
  CP_Ct1: 'mCurrent1',
  CP_Ct2: 'mCurrent2',
  CP_Ct3: 'mCurrent3',
  VP_Volt: 'voltage',
  CP_Volt1: 'voltage1',
  CP_Volt2: 'voltage2',
  CP_Volt3: 'voltage3',
  DCP_Status1: 'status1',
  DCP_Status2: 'status2',
  DCP_Status3: 'status3',
  DCP_Counter1: 'counter1',
  DCP_Counter2: 'counter2',
  DCP_Counter3: 'counter3',
  TH_Temp: 'celsiusTemperature',
  TH_Humi: 'relativeHumidity',
  TH_TempHumi: 'tempHum',
  TX3_Temp1: 'temperature1',
  TX3_Temp2: 'temperature2',
  TX3_Temp3: 'temperature3',
  VB_Temp: 'celsiusTemperature',
  VB_RMS: 'accelerationRMS',
  VB_FreqAcc: 'freqAcc',
  VB_RmsTemp: 'rmsTemp',
  VB_Freq: 'frequency',
  VB_Acc: 'acceleration',
  VB_Kurtosis: 'kurtosis',
  VSN_FreqVel: 'freqVel',
  VSN_ACC_RMS: 'accRMS',
  VSN_VEL_RMS: 'velRMS',
  VSN_Acc: 'acc',
  VSN_AccFreq: 'accFreq',
  VSN_Vel: 'vel',
  VSN_VelFreq: 'velFreq',
  Data: 'data',
  DCP_CurrentStatus1: 'currentStatus1',
  DCP_CurrentStatus2: 'currentStatus2',
  DCP_CurrentStatus3: 'currentStatus3',
};

export const dataOption = {
  current: {
    unit: 'mA',
    min: 4,
    max: 20,
    low: 20,
    high: 20,
  },
  current1: {
    unit: 'A',
    min: 0,
    max: 100,
    low: 100,
    high: 100,
  },
  current2: {
    unit: 'A',
    min: 0,
    max: 100,
    low: 100,
    high: 100,
  },
  mCurrent1: {
    unit: 'mA',
    min: 4,
    max: 20,
    low: 20,
    high: 20,
  },
  mCurrent2: {
    unit: 'mA',
    min: 4,
    max: 20,
    low: 20,
    high: 20,
  },
  mCurrent3: {
    unit: 'mA',
    min: 4,
    max: 20,
    low: 20,
    high: 20,
  },
  voltage: {
    unit: 'V',
    min: 0,
    max: 5,
    low: 5,
    high: 5,
  },
  voltage1: {
    unit: 'V',
    min: 0,
    max: 5,
    low: 5,
    high: 5,
  },
  voltage2: {
    unit: 'V',
    min: 0,
    max: 5,
    low: 5,
    high: 5,
  },
  voltage3: {
    unit: 'V',
    min: 0,
    max: 5,
    low: 5,
    high: 5,
  },
  status1: {
    unit: '',
    min: 1,
    max: 256,
    low: 256,
    high: 256,
  },
  status2: {
    unit: '',
    min: 1,
    max: 256,
    low: 256,
    high: 256,
  },
  status3: {
    unit: '',
    min: 1,
    max: 256,
    low: 256,
    high: 256,
  },
  celsiusTemperature: {
    unit: '℃',
    min: -30,
    max: 50,
    low: 18,
    high: 25,
  },
  relativeHumidity: {
    unit: 'RH%',
    min: 20,
    max: 100,
    low: 45,
    high: 65,
  },
  temperature1: {
    unit: '℃',
    min: -30,
    max: 50,
    low: 18,
    high: 25,
  },
  temperature2: {
    unit: '℃',
    min: -30,
    max: 50,
    low: 18,
    high: 25,
  },
  temperature3: {
    unit: '℃',
    min: -30,
    max: 50,
    low: 18,
    high: 25,
  },
  accelerationRMS: {
    unit: 'm/s²',
    min: 0,
    max: 10,
    low: 10,
    high: 10,
  },
  freqAcc: {},
  frequency: {
    unit: 'Hz',
    min: 10,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  acceleration: {
    unit: 'm/s²',
    min: -10,
    max: 10,
    low: 10,
    high: 10,
  },
  rssi: {
    unit: 'dBm',
    min: -100,
    max: 0,
    low: -60,
    high: 0,
  },
  batteryVoltage: {
    unit: 'V',
    min: 1,
    max: 5,
    low: 5,
    high: 5,
  },
  accRMS: {
    unit: 'm/s²',
    min: 0,
    max: 10,
    low: 10,
    high: 10,
  },
  velRMS: {
    unit: 'mm/s',
    min: 0,
    max: 100,
    low: 100,
    high: 100,
  },
  accFreq: {
    unit: 'Hz',
    min: 10,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  velFreq: {
    unit: 'Hz',
    min: 10,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  vel: {
    unit: 'mm/s',
    min: 0,
    max: 100,
    low: 100,
    high: 100,
  },
  'data1(01)': {
    unit: '℃',
    min: -30,
    max: 50,
    low: 18,
    high: 25,
  },
  'data2(01)': {
    unit: 'RH%',
    min: 20,
    max: 100,
    low: 45,
    high: 65,
  },
  'data1(FE)': {
    unit: '℃',
    min: -30,
    max: 50,
    low: 18,
    high: 25,
  },
  'data2(FE)': {
    unit: 'V',
    min: 1,
    max: 25,
    low: 25,
    high: 25,
  },
  'data3(FE)': {
    unit: 'V',
    min: 1,
    max: 25,
    low: 25,
    high: 25,
  },
  'data1(12)': {
    unit: 'Time',
    min: 0,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data2(12)': {
    unit: 'A',
    min: 0,
    max: 100,
    low: 100,
    high: 100,
  },
  'data3(12)': {
    unit: 'A',
    min: 0,
    max: 100,
    low: 100,
    high: 100,
  },
  'data4(12)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data5(12)': {
    unit: 'A',
    min: 0,
    max: 100,
    low: 100,
    high: 100,
  },
  'data6(12)': {
    unit: 'A',
    min: 0,
    max: 100,
    low: 100,
    high: 100,
  },
  'data7(12)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data1(10)': {
    unit: 'Time',
    min: 0,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data2(10)': {
    unit: 'mA',
    min: 4,
    max: 20,
    low: 20,
    high: 20,
  },
  'data3(10)': {
    unit: 'Time',
    min: 0,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data4(10)': {
    unit: 'mA',
    min: 4,
    max: 20,
    low: 20,
    high: 20,
  },
  'data5(10)': {
    unit: 'Time',
    min: 0,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data1(35)': {
    unit: '-',
    min: 0,
    max: 100,
    low: 100,
    high: 100,
  },
  'data1(29)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data2(29)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data3(29)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data4(29)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data5(29)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data6(29)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data7(29)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data8(29)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data9(29)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data10(29)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data11(29)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data12(29)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data1(07)': {
    unit: '℃',
    min: -30,
    max: 50,
    low: 18,
    high: 25,
  },
  'data2(07)': {
    unit: '℃',
    min: -30,
    max: 50,
    low: 18,
    high: 25,
  },
  'data3(07)': {
    unit: '℃',
    min: -30,
    max: 50,
    low: 18,
    high: 25,
  },
  'data1(1B)': {
    unit: 'mA',
    min: 4,
    max: 20,
    low: 20,
    high: 20,
  },
  'data2(1B)': {
    unit: 'mA',
    min: 4,
    max: 20,
    low: 20,
    high: 20,
  },
  'data3(1B)': {
    unit: 'mA',
    min: 4,
    max: 20,
    low: 20,
    high: 20,
  },
  'data1(1C)': {
    unit: 'V',
    min: 0,
    max: 5,
    low: 5,
    high: 5,
  },
  'data2(1C)': {
    unit: 'V',
    min: 0,
    max: 5,
    low: 5,
    high: 5,
  },
  'data3(1C)': {
    unit: 'V',
    min: 0,
    max: 5,
    low: 5,
    high: 5,
  },
  'data1(13)': {
    unit: 'Time',
    min: 0,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data2(13)': {
    unit: 'V',
    min: 0,
    max: 5,
    low: 5,
    high: 5,
  },
  'data3(13)': {
    unit: 'Time',
    min: 0,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data4(13)': {
    unit: 'V',
    min: 0,
    max: 5,
    low: 5,
    high: 5,
  },
  'data5(13)': {
    unit: 'Time',
    min: 0,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data1(09)': {
    unit: 'Hz',
    min: 10,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data2(09)': {
    unit: 'm/s²',
    min: -10,
    max: 10,
    low: 10,
    high: 10,
  },
  'data3(09)': {
    unit: 'Hz',
    min: 10,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data4(09)': {
    unit: 'm/s²',
    min: -10,
    max: 10,
    low: 10,
    high: 10,
  },
  'data5(09)': {
    unit: 'Hz',
    min: 10,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data6(09)': {
    unit: 'm/s²',
    min: -10,
    max: 10,
    low: 10,
    high: 10,
  },
  'data7(09)': {
    unit: 'Hz',
    min: 10,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data8(09)': {
    unit: 'm/s²',
    min: -10,
    max: 10,
    low: 10,
    high: 10,
  },
  'data9(09)': {
    unit: 'Hz',
    min: 10,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data10(09)': {
    unit: 'm/s²',
    min: -10,
    max: 10,
    low: 10,
    high: 10,
  },
  'data11(09)': {
    unit: 'm/s²',
    min: 0,
    max: 10,
    low: 10,
    high: 10,
  },
  'data12(09)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data13(09)': {
    unit: '℃',
    min: -30,
    max: 50,
    low: 18,
    high: 25,
  },
  'data1(18)': {
    unit: 'Hz',
    min: 10,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data2(18)': {
    unit: 'm/s²',
    min: -10,
    max: 10,
    low: 10,
    high: 10,
  },
  'data3(18)': {
    unit: 'Hz',
    min: 10,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data4(18)': {
    unit: 'm/s²',
    min: -10,
    max: 10,
    low: 10,
    high: 10,
  },
  'data5(18)': {
    unit: 'm/s²',
    min: 0,
    max: 10,
    low: 10,
    high: 10,
  },
  'data6(18)': {
    unit: 'Hz',
    min: 10,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data7(18)': {
    unit: 'mm/s',
    min: 0,
    max: 100,
    low: 100,
    high: 100,
  },
  'data8(18)': {
    unit: 'Hz',
    min: 10,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data9(18)': {
    unit: 'mm/s',
    min: 0,
    max: 100,
    low: 100,
    high: 100,
  },
  'data10(18)': {
    unit: 'Hz',
    min: 10,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data11(18)': {
    unit: 'mm/s',
    min: 0,
    max: 100,
    low: 100,
    high: 100,
  },
  'data12(18)': {
    unit: 'mm/s',
    min: 0,
    max: 100,
    low: 100,
    high: 100,
  },
  'data13(18)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data14(18)': {
    unit: '℃',
    min: -30,
    max: 50,
    low: 18,
    high: 25,
  },
  'data1(1D)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data2(1D)': {
    unit: 'Time',
    min: 0,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data3(1D)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data4(1D)': {
    unit: 'Time',
    min: 0,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  'data5(1D)': {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
  'data6(1D)': {
    unit: 'Time',
    min: 0,
    max: 10000,
    low: 10000,
    high: 10000,
  },
  NoData: {
    unit: '-',
    min: 0,
    max: 20000,
    low: 20000,
    high: 20000,
  },
};

export const dataRange = {
  A: {
    min: 0,
    max: 100,
  },
  '℃': {
    min: -30,
    max: 50,
  },
  'RH%': {
    min: 20,
    max: 100,
  },
  RMS: {
    min: 0,
    max: 100,
  },
  Hz: {
    min: 10,
    max: 10000,
  },
  'm/s²': {
    min: 0,
    max: 10,
  },
  dBm: {
    min: -100,
    max: 0,
  },
  V: {
    min: 0,
    max: 5,
  },
  mA: {
    min: 4,
    max: 20,
  },
  '': {
    min: 1,
    max: 256,
  },
  'mm/s': {
    min: 0,
    max: 100,
  },
  'inference result': {
    min: -10,
    max: 10,
  },
  Time: {
    min: 0,
    max: 10000,
  },
  score: {
    min: 0,
    max: 255,
  },
  lux: {
    min: 0,
    max: 100000,
  },
  'on/off': {
    min: 0,
    max: 1,
  },
  index: {
    min: 0,
    max: 65535,
  },
  '-': {
    min: -20000,
    max: 20000,
  },
};

export const dateRangeDefaultName = 'i18n week so far';

export const defaultChartColorList = [
  '#2ec7c9',
  '#b6a2de',
  '#5ab1ef',
  '#ffb980',
  '#d87a80',
  '#8d98b3',
  '#e5cf0d',
  '#97b552',
  '#95706d',
  '#dc69aa',
  '#07a2a4',
  '#9a7fd1',
  '#588dd5',
  '#f5994e',
  '#c05050',
  '#59678c',
  '#c9ab00',
  '#7eb00a',
  '#6f5553',
  '#c14089',
];

export const roleId = {
  // admin: 1,
  // general: 2,
  // guest: 3,
  admin: '1',
  manager: '2',
  guest: '3',
  disabled: '4',
  uncontracted: '5',
};

export const permissionId = {
  DBoard_Editpreset: 100001,
  Device: 2000,
  Dev_Vw_Chg: 200001,
  Dev_Setting: 200002,
  Dev_Delete: 200003,
  Dev_EditMode: 200004,
  Dev_Graph: 200005,
  Dev_Edit_Preset: 200006,
  Dev_Add: 200007,
  Auto_Renewal: 200008,
  Formula_Creation: 200009,
  Map: 3000,
  Map_Change_Background: 300001,
  Map_Move_marker: 300002,
  Map_Reset_Icon: 300003,
  Alert: 4000,
  Alert_Condition: 4001,
  Alert_Condition_Edit: 400103,
  Alert_Email: 4002,
  Alert_History: 4003,
  Confirm_History: 4004,
  User_Mgr: 5000,
  User_List: 500001,
  User_Reset_Manager: 500002,
  User_Reset_Guest: 500003,
  Sys_Info_SubG: 6001,
  Sys_Info_SubG_Edit: 600102,
  Sys_Info_Firmware_update: 600204,
  Sys_Info_Shutdown: 600209,
  Sys_Info_Sys_Clock: 6003,
  Sys_Info_Sys_Clock_NTP: 600301,
  Sys_Info_Sys_Time: 600302,
  Sys_Info_Sys_Time_Zone: 600303,
  Sys_Info_Sys_NWK: 6004,
  Sys_Info_Sys_NWK_SubGHz_UDP: 600402,
  Sys_Info_Sys_NWK_SubGHz_Destination: 600403,
  Sys_Info_Sys_NWK_Edit_Ethernet: 600404,
  Sys_Info_Sys_NWK_Edit_WLAN: 600405,
  Sys_Info_Sys_NWK_Edit_WLAN_AP: 600406,
  Sys_Info_Sub_Gateway: 6005,
  SensorCSV_Log: 6006,
  GW: 7000,
  GW_Vw_Chg: 700001,
  GW_Setting: 700002,
  GW_Add: 700003,
  GW_EditMode: 700004,
  GW_Edit_Preset: 700006,
  Area: 8000,
  Area_Delete: 800003,
  Area_EditMode: 800004,
  Area_Add: 800007,
  Area_GWs_Register: 800102,
};

export const scatterChartIndex = {
  time: 0,
  acc: 1,
  freq: 2,
  vel: 3,
  rms: 4,
  temp: 5,
  hum: 6,
};

export const max_user_num = 20;

export const devStatus = {
  offline: '0',
  normal: '1',
  installation: '2',
  cautain: '3',
  warning: '4',
  rangeOver: '5',
};

export const devStatusMap = new Map([
  ['0', i18n.global.t('device.offline')],
  ['1', i18n.global.t('device.normal')],
  ['2', i18n.global.t('device.installation')],
  ['3', i18n.global.t('device.cautain')],
  ['4', i18n.global.t('device.warning')],
  ['5', i18n.global.t('device.rangeOver')],
]);

export const gwDevStatus = {
  offline: '0',
  normal: '1',
  deactivated: '2',
  occupied: '3',
};

export const gwDevStatusMap = new Map([
  ['0', i18n.global.t('gateway.offline')],
  ['1', i18n.global.t('gateway.normal')],
  ['2', i18n.global.t('gateway.deactivated')],
  ['3', i18n.global.t('gateway.occupied')],
]);

export const areaStatus = {
  gwOccupied: '0',
  normal: '1',
  deleted: '2',
};

export const initArea = 'undefined';

export const native_data_num_map = new Map([
  ['12', 7],
  ['01', 2],
  ['09', 13],
  ['07', 3],
  ['10', 5],
  ['1B', 3],
  ['1C', 3],
  ['13', 5],
  ['18', 14],
  ['1D', 6],
  ['29', 12],
  ['35', 1],
  ['FE', 3],
  // ['2C',] //TODO
]);

export const native_data_type_map = new Map([
  [
    '12',
    [
      {
        value: 'current1',
        label: i18n.global.t('device.current1'),
      },
      {
        value: 'current2',
        label: i18n.global.t('device.current2'),
      },
    ],
  ],
  [
    '01',
    [
      {
        value: 'celsiusTemperature',
        label: i18n.global.t('device.temperature'),
      },
      {
        value: 'relativeHumidity',
        label: i18n.global.t('device.humidity'),
      },
    ],
  ],
  [
    '09',
    [
      {
        value: 'frequency1',
        label: i18n.global.t('device.frequency') + '1',
      },
      {
        value: 'frequency2',
        label: i18n.global.t('device.frequency') + '2',
      },
      {
        value: 'frequency3',
        label: i18n.global.t('device.frequency') + '3',
      },
      {
        value: 'frequency4',
        label: i18n.global.t('device.frequency') + '4',
      },
      {
        value: 'frequency5',
        label: i18n.global.t('device.frequency') + '5',
      },
      {
        value: 'acceleration1',
        label: i18n.global.t('device.acceleration') + '1',
      },
      {
        value: 'acceleration2',
        label: i18n.global.t('device.acceleration') + '2',
      },
      {
        value: 'acceleration3',
        label: i18n.global.t('device.acceleration') + '3',
      },
      {
        value: 'acceleration4',
        label: i18n.global.t('device.acceleration') + '4',
      },
      {
        value: 'acceleration5',
        label: i18n.global.t('device.acceleration') + '5',
      },
      {
        value: 'kurtosis',
        label: i18n.global.t('device.kurtosis'),
      },
      {
        value: 'celsiusTemperature',
        label: i18n.global.t('device.celsiusTemperature'),
      },
      {
        value: 'accelerationRMS',
        label: i18n.global.t('device.accelerationRMS'),
      },
    ],
  ],
  [
    '07',
    [
      {
        value: 'temperature1',
        label: i18n.global.t('device.temperature1'),
      },
      {
        value: 'temperature2',
        label: i18n.global.t('device.temperature2'),
      },
      {
        value: 'temperature3',
        label: i18n.global.t('device.temperature3'),
      },
    ],
  ],
  [
    '10',
    [
      {
        value: 'current',
        label: i18n.global.t('device.current'),
      },
    ],
  ],
  [
    '1B',
    [
      {
        value: 'mCurrent1',
        label: i18n.global.t('device.current1'),
      },
      {
        value: 'mCurrent2',
        label: i18n.global.t('device.current2'),
      },
      {
        value: 'mCurrent3',
        label: i18n.global.t('device.current3'),
      },
    ],
  ],
  [
    '13',
    [
      {
        value: 'voltage',
        label: i18n.global.t('device.voltage'),
      },
    ],
  ],
  [
    '1C',
    [
      {
        value: 'voltage1',
        label: i18n.global.t('device.voltage1'),
      },
      {
        value: 'voltage2',
        label: i18n.global.t('device.voltage2'),
      },
      {
        value: 'voltage3',
        label: i18n.global.t('device.voltage3'),
      },
    ],
  ],
  [
    '1D',
    [
      {
        value: 'currentStatus1',
        label: i18n.global.t('device.status1'),
      },
      {
        value: 'currentStatus2',
        label: i18n.global.t('device.status2'),
      },
      {
        value: 'currentStatus3',
        label: i18n.global.t('device.status3'),
      },
    ],
  ],
  [
    '18',
    [
      {
        value: 'accFreq1',
        label: i18n.global.t('device.accFreq') + '1',
      },
      {
        value: 'accFreq2',
        label: i18n.global.t('device.accFreq') + '2',
      },
      {
        value: 'acc1',
        label: i18n.global.t('device.acceleration') + '1',
      },
      {
        value: 'acc2',
        label: i18n.global.t('device.acceleration') + '2',
      },
      {
        value: 'accRMS',
        label: i18n.global.t('device.accelerationRMS'),
      },
      {
        value: 'velFreq1',
        label: i18n.global.t('device.velFreq') + '1',
      },
      {
        value: 'velFreq2',
        label: i18n.global.t('device.velFreq') + '2',
      },
      {
        value: 'velFreq3',
        label: i18n.global.t('device.velFreq') + '3',
      },
      {
        value: 'vel1',
        label: i18n.global.t('device.vel') + '1',
      },
      {
        value: 'vel2',
        label: i18n.global.t('device.vel') + '2',
      },
      {
        value: 'vel3',
        label: i18n.global.t('device.vel') + '3',
      },
      {
        value: 'velRMS',
        label: i18n.global.t('device.velRMS'),
      },
      {
        value: 'kurtosis',
        label: i18n.global.t('device.kurtosis'),
      },
      {
        value: 'celsiusTemperature',
        label: i18n.global.t('device.celsiusTemperature'),
      },
    ],
  ],
]);

export const settingFileType = {
  nodeList: 'NodeList',
  dataUnit: 'DataUnit',
  application: 'Application',
  replicated: 'Replicated',
  settingFile: 'settingFile',
};

export const columnType = {
  data: 'data',
  selection: 'selection',
  group: 'group',
  unitId: 'unitId',
  networkId: 'networkId',
  serialNo: 'serialNo',
  wirelessSetting: 'wirelessSetting',
  fwVer: 'fwVer',
  icon: 'icon',
  battery: 'batteryVoltage',
  devStatus: 'devStatus',
  dataType: 'dataType',
  rssi: 'rssi',
  elpasedTime: 'elpasedTime',
  receiveTime: 'receiveTime',
  joinTime: 'joinTime',
  autoConfig: 'autoConfig',
  route: 'route',
  lastUpdateTime: 'lastUpdateTime',
  measCycle: 'measCycle',
  transCycle: 'transCycle',
  transMethod: 'transMethod',
  rssiTime: 'rssiTime',
  typeName: 'devType',
  name: 'name',
  otherSetting: 'otherSetting',
  autoConfigSchedule: 'autoConfigSchedule',
};

export const gatewayColumnType = {
  selection: 'selection',
  gatewayId: 'gatewayId',
  areaId: 'areaId',
  areaLabel: 'areaLabel',
  // devType: 'devType',
  fwVer: 'fwVer',
  simInfo: 'simInfo',
  name: 'name',
  // icon: 'icon',
  parentId: 'parentId',
  portNo: 'portNo',
  panId: 'panId',
  channelNo: 'channelNo',
  isEncryption: 'isEncryption',
  macAddress: 'macAddress',
  status: 'status',
  // elpasedTime: 'elpasedTime',
  lastDateTime: 'lastDateTime',
  deviceList: 'deviceList',
  addDevice: 'addDevice',
  userRole: 'userRole',
};

export const areaColumnType = {
  selection: 'selection',
  name: 'name',
  // status: 'status',
  gatewayList: 'gatewayList',
  registerGateway: 'registerGateway',
  // lastDateTime: 'lastDateTime',
};

export const userColumnType = {
  selection: 'selection',
  userName: 'userName',
  serviceName: 'serviceName',
  userRole: 'userRole',
  lastLogin: 'lastLogin',
  adminPrivilege: 'adminPrivilege',
  gatewayInfo: 'gatewayInfo',
};

export const intervalMap = new Map([
  ['0101', '5' + i18n.global.t('device.sec')],
  ['0202', '15' + i18n.global.t('device.sec')],
  ['0303', '30' + i18n.global.t('device.sec')],
  ['0404', '1' + i18n.global.t('device.min')],
  ['0505', '5' + i18n.global.t('device.min')],
  ['0606', '10' + i18n.global.t('device.min')],
  ['0707', '15' + i18n.global.t('device.min')],
  ['0808', '30' + i18n.global.t('device.min')],
  ['0909', '1' + i18n.global.t('device.hour')],
  ['0A0A', '2' + i18n.global.t('device.hour')],
  ['0B0B', '6' + i18n.global.t('device.hour')],
  ['0C0C', '12' + i18n.global.t('device.hour')],
  ['0D0D', '24' + i18n.global.t('device.hour')],
]);

export const transMethodMap = new Map([
  ['00', i18n.global.t('device.addDeviceDrawer.broadcast')],
  ['01', i18n.global.t('device.addDeviceDrawer.unicast')],
  ['02', i18n.global.t('device.addDeviceDrawer.sync')],
]);

export const rssiTimeMap = new Map([
  ['00', i18n.global.t('device.none')],
  ['03', '30' + i18n.global.t('device.addDeviceDrawer.sec')],
  ['06', '1' + i18n.global.t('device.min')],
  ['0C', '2' + i18n.global.t('device.min')],
  ['12', '3' + i18n.global.t('device.min')],
  ['18', '4' + i18n.global.t('device.min')],
  ['1E', '5' + i18n.global.t('device.min')],
  ['3C', '10' + i18n.global.t('device.min')],
  ['B4', '30' + i18n.global.t('device.min')],
]);

// TEVセンサー用の設置モード継続時間マップ
export const tevRssiTimeMap = new Map([
  ['00', '12' + i18n.global.t('device.hour')],
  ['01', '30' + i18n.global.t('device.addDeviceDrawer.sec')],
  ['02', '30' + i18n.global.t('device.min')],
  ['03', '2' + i18n.global.t('device.hour')],
  ['04', '6' + i18n.global.t('device.hour')],
]);

export const intervalSecMap = new Map([
  ['0101', 5],
  ['0202', 15],
  ['0303', 30],
  ['0404', 1 * 60],
  ['0505', 5 * 60],
  ['0606', 10 * 60],
  ['0707', 15 * 60],
  ['0808', 30 * 60],
  ['0909', 1 * 60 * 60],
  ['0A0A', 2 * 60 * 60],
  ['0B0B', 6 * 60 * 60],
  ['0C0C', 12 * 60 * 60],
  ['0D0D', 24 * 60 * 60],
]);

export const searchDevTypeMap = new Map([
  [i18n.global.t('device.ctTitle'), '12'],
  [i18n.global.t('device.tempHumTitle'), '01'],
  [i18n.global.t('device.vbTitle'), '09'],
  [i18n.global.t('device.tempX3Title'), '07'],
  [i18n.global.t('device.ctPulseTitle'), '10'],
  [i18n.global.t('device.voltagePulseTitle'), '13'],
  [i18n.global.t('device.ctPulseX3Title'), '1B'],
  [i18n.global.t('device.voltagePulseX3Title'), '1C'],
  [i18n.global.t('device.dryContactPulseTitle'), '1D'],
  [i18n.global.t('device.vsnTitle'), '18'],
  [i18n.global.t('device.repeatTitle'), 'FE'],
  [i18n.global.t('device.aiCameraTitle'), '29'],
  [i18n.global.t('device.valvePositionTitle'), '35'],
  [i18n.global.t('device.rwmUnitTitle'), '2C'],
  [i18n.global.t('device.tevTitle'), '2D'],
  [i18n.global.t('device.vdn2Title'), '2B'],
  [i18n.global.t('device.notSet'), 'Unknown'],
]);

/*
export const searchGWDevTypeMap = new Map([
  [i18n.global.t('gateway.a6eTitle'), 'ArmadilloA6E'],
  [i18n.global.t('gateway.notSet'), 'Unknown'],
]);
*/

export const devTypeTitle = new Map([
  ['01', i18n.global.t('device.tempHumTitle')],
  ['09', i18n.global.t('device.vbTitle')],
  ['12', i18n.global.t('device.ctTitle')],
  ['07', i18n.global.t('device.tempX3Title')],
  ['FE', i18n.global.t('device.repeatTitle')],
  ['24', i18n.global.t('device.antiExplosionRepeaterTitle')],
  ['10', i18n.global.t('device.ctPulseTitle')],
  ['1B', i18n.global.t('device.ctPulseX3Title')],
  ['13', i18n.global.t('device.voltagePulseTitle')],
  ['1C', i18n.global.t('device.voltagePulseX3Title')],
  ['1D', i18n.global.t('device.dryContactPulseTitle')],
  ['18', i18n.global.t('device.vsnTitle')],
  ['25', i18n.global.t('device.antiExplosionVsnTitle')],
  ['29', i18n.global.t('device.aiCameraTitle')],
  ['35', i18n.global.t('device.valvePositionTitle')],
  ['2F', i18n.global.t('device.vb2TFTitle')],
  ['1E', i18n.global.t('device.liquidLeakageTitle')],
  ['2B', i18n.global.t('device.vdn2Title')],
  ['2C', i18n.global.t('device.rwmUnitTitle')],
  ['2D', i18n.global.t('device.tevTitle')],
]);

export const devConfigOptions = {
  // channelOptions: [{
  //   value: '28',
  //   label: '0x28 (923.9MHz)'
  // }, {
  //   value: '29',
  //   label: '0x29 (924.1MHz)'
  // }, {
  //   value: '2A',
  //   label: '0x2A (924.3MHz)'
  // }, {
  //   value: '2B',
  //   label: '0x2B (924.5MHz)'
  // }, {
  //   value: '2C',
  //   label: '0x2C (924.7MHz)'
  // }, {
  //   value: '2D',
  //   label: '0x2D (924.9MHz)'
  // }, {
  //   value: '2E',
  //   label: '0x2E (925.1MHz)'
  // }, {
  //   value: '2F',
  //   label: '0x2F (925.3MHz)'
  // }, {
  //   value: '30',
  //   label: '0x30 (925.5MHz)'
  // }, {
  //   value: '31',
  //   label: '0x31 (925.7MHz)'
  // }, {
  //   value: '32',
  //   label: '0x32 (925.9MHz)'
  // }, {
  //   value: '33',
  //   label: '0x33 (926.1MHz)'
  // }, {
  //   value: '34',
  //   label: '0x34 (926.3MHz)'
  // }, {
  //   value: '35',
  //   label: '0x35 (926.5MHz)'
  // }, {
  //   value: '36',
  //   label: '0x36 (926.7MHz)'
  // }, {
  //   value: '37',
  //   label: '0x37 (926.9MHz)'
  // }],
  autoConfigOptions: [
    {
      value: '01',
      label: i18n.global.t('device.addDeviceDrawer.autoConfigUpdate'),
    },
    {
      value: '00',
      label: i18n.global.t('device.addDeviceDrawer.autoConfigNoUpdate'),
    },
  ],
  repeatPeriodicTransmissionOptions: [
    {
      value: '01',
      label: i18n.global.t('device.addDeviceDrawer.periodicTransmissionEnable'),
    },
    {
      value: 'FF',
      label: i18n.global.t('device.addDeviceDrawer.periodicTransmissionDisable'),
    },
  ],
  vdn2AutoConfigOptions: [
    {
      value: '00',
      label: i18n.global.t('device.addDeviceDrawer.noUpdate'),
    },
    {
      value: '01',
      label: '24' + i18n.global.t('device.addDeviceDrawer.hour') + i18n.global.t('device.addDeviceDrawer.every'),
    },
    {
      value: '02',
      label: '12' + i18n.global.t('device.addDeviceDrawer.hour') + i18n.global.t('device.addDeviceDrawer.every'),
    },
    {
      value: '03',
      label: '6' + i18n.global.t('device.addDeviceDrawer.hour') + i18n.global.t('device.addDeviceDrawer.every'),
    },
    {
      value: '04',
      label: '2' + i18n.global.t('device.addDeviceDrawer.hour') + i18n.global.t('device.addDeviceDrawer.every'),
    },
    {
      value: '05',
      label: '1' + i18n.global.t('device.addDeviceDrawer.hour') + i18n.global.t('device.addDeviceDrawer.every'),
    },
  ],
  tevAutoConfigOptions: [
    {
      value: '00',
      label: i18n.global.t('device.addDeviceDrawer.noUpdate'),
    },
    {
      value: '01',
      label: '24' + i18n.global.t('device.addDeviceDrawer.hour') + i18n.global.t('device.addDeviceDrawer.every'),
    },
    {
      value: '02',
      label: '12' + i18n.global.t('device.addDeviceDrawer.hour') + i18n.global.t('device.addDeviceDrawer.every'),
    },
    {
      value: '03',
      label: '6' + i18n.global.t('device.addDeviceDrawer.hour') + i18n.global.t('device.addDeviceDrawer.every'),
    },
    {
      value: '04',
      label: '2' + i18n.global.t('device.addDeviceDrawer.hour') + i18n.global.t('device.addDeviceDrawer.every'),
    },
    {
      value: '05',
      label: '1' + i18n.global.t('device.addDeviceDrawer.hour') + i18n.global.t('device.addDeviceDrawer.every'),
    },
  ],
  tevRetryIntervalOptions: [
    {
      value: '02',
      label: '2' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '03',
      label: '3' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '05',
      label: '5' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '06',
      label: '6' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '0A',
      label: '10' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '0B',
      label: '11' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '14',
      label: '20' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '15',
      label: '21' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '1D',
      label: '29' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '1E',
      label: '30' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
  ],
  tevRssiTimeOptions: [
    {
      value: '00',
      label: '12' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '01',
      label: '30' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '02',
      label: '30' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '03',
      label: '2' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '04',
      label: '6' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
  ],
  tevTransMethodOptions: [
    {
      value: '00',
      label: i18n.global.t('device.addDeviceDrawer.broadcast'),
    },
    {
      value: '01',
      label: i18n.global.t('device.addDeviceDrawer.unicast'),
    },
  ],
  solarOptions: [
    {
      value: '01',
      label: i18n.global.t('device.addDeviceDrawer.solarEnable'),
    },
    {
      value: '00',
      label: i18n.global.t('device.addDeviceDrawer.solarDisable'),
    },
  ],

  intervalOptions: [
    {
      value: '0101',
      label: '5' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '0202',
      label: '15' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '0303',
      label: '30' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '0404',
      label: '1' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0505',
      label: '5' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0606',
      label: '10' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0707',
      label: '15' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0808',
      label: '30' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0909',
      label: '1' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0A0A',
      label: '2' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0B0B',
      label: '6' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0C0C',
      label: '12' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0D0D',
      label: '24' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
  ],
  dryContactPulseIntervalOptions: [
    {
      value: '0404',
      label: '1' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0505',
      label: '5' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0606',
      label: '10' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0707',
      label: '15' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0808',
      label: '30' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0909',
      label: '1' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0A0A',
      label: '2' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0B0B',
      label: '6' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0C0C',
      label: '12' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0D0D',
      label: '24' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
  ],
  vibrationIntervalOptions: [
    {
      value: '0202',
      label: '15' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '0303',
      label: '30' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '0404',
      label: '1' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0505',
      label: '5' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0606',
      label: '10' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0707',
      label: '15' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0808',
      label: '30' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0909',
      label: '1' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0A0A',
      label: '2' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0B0B',
      label: '6' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0C0C',
      label: '12' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0D0D',
      label: '24' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
  ],
  vsnIntervalOptions: [
    {
      value: '0404',
      label: '1' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0505',
      label: '5' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0606',
      label: '10' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0707',
      label: '15' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0808',
      label: '30' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0909',
      label: '1' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0A0A',
      label: '2' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0B0B',
      label: '6' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0C0C',
      label: '12' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0D0D',
      label: '24' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
  ],
  rwmIntervalOptions: [
    {
      value: '0202',
      label: '15' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '0303',
      label: '30' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '0404',
      label: '1' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0505',
      label: '5' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0606',
      label: '10' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0707',
      label: '15' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0808',
      label: '30' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0909',
      label: '1' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0A0A',
      label: '2' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
  ],
  repeatIntervalOptions: [
    {
      value: '0B0B',
      label: '6' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0C0C',
      label: '12' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0D0D',
      label: '24' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
  ],
  rssiTimeOptions: [
    {
      value: '00',
      label: i18n.global.t('device.addDeviceDrawer.noTimeout'),
    },
    {
      value: '03',
      label: '30' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '06',
      label: '1' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '0C',
      label: '2' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '12',
      label: '3' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '18',
      label: '4' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '1E',
      label: '5' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '3C',
      label: '10' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: 'B4',
      label: '30' + i18n.global.t('device.addDeviceDrawer.min'),
    },
  ],
  aiCameraRssiTimeOptions: [
    {
      value: '03',
      label: '30' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '0A',
      label: '2' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0B',
      label: '6' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
    {
      value: '0C',
      label: '12' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
  ],
  detectOptions: [
    {
      value: '00',
      label: i18n.global.t('device.addDeviceDrawer.wakeDetectDisable'),
    },
    {
      value: '01',
      label: i18n.global.t('device.addDeviceDrawer.wakeDetectEnable'),
    },
  ],
  detectRetryOptions: [
    {
      value: '00',
      label: i18n.global.t('device.addDeviceDrawer.none'),
    },
    {
      value: '01',
      label: '1',
    },
    {
      value: '02',
      label: '2',
    },
    {
      value: '03',
      label: '3',
    },
    {
      value: '04',
      label: '4',
    },
    {
      value: '05',
      label: '5',
    },
    {
      value: '06',
      label: '6',
    },
    {
      value: '07',
      label: '7',
    },
    {
      value: '08',
      label: '8',
    },
    {
      value: '09',
      label: '9',
    },
    {
      value: '0A',
      label: '10',
    },
    {
      value: '0B',
      label: '11',
    },
    {
      value: '0C',
      label: '12',
    },
    {
      value: 'FF',
      label: i18n.global.t('device.addDeviceDrawer.untilDetect'),
    },
  ],
  retryIntervalOptions: [
    {
      value: '00',
      label: '15' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '01',
      label: '30' + i18n.global.t('device.addDeviceDrawer.sec'),
    },
    {
      value: '02',
      label: '1' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '03',
      label: '5' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '04',
      label: '10' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '05',
      label: '15' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '06',
      label: '30' + i18n.global.t('device.addDeviceDrawer.min'),
    },
    {
      value: '07',
      label: '1' + i18n.global.t('device.addDeviceDrawer.hour'),
    },
  ],
  fftEnableOptions: [
    {
      value: '00',
      label: i18n.global.t('device.addDeviceDrawer.disable'),
    },
    {
      value: '01',
      label: i18n.global.t('device.addDeviceDrawer.enable'),
    },
  ],
  fftReportEnableOptions: [
    {
      value: '00',
      label: i18n.global.t('device.addDeviceDrawer.disable'),
    },
    {
      value: '01',
      label: i18n.global.t('device.addDeviceDrawer.enable'),
    },
  ],
  routerEnableOptions: [
    {
      value: '00',
      label: i18n.global.t('device.addDeviceDrawer.disable'),
    },
    {
      value: '01',
      label: i18n.global.t('device.addDeviceDrawer.enable'),
    },
  ],
  dataStrageEnableOptions: [
    {
      value: '00',
      label: i18n.global.t('device.addDeviceDrawer.disable'),
    },
    {
      value: '01',
      label: i18n.global.t('device.addDeviceDrawer.enable'),
    },
  ],
  radioMonitorExclusionOptions: [
    {
      value: '00',
      label: i18n.global.t('device.addDeviceDrawer.noExclusion'),
    },
    {
      value: '01',
      label: i18n.global.t('device.addDeviceDrawer.selfSendExclusion'),
    },
  ],
  transMethodOptions: [
    {
      value: '00',
      label: i18n.global.t('device.addDeviceDrawer.broadcast'),
    },
    {
      value: '01',
      label: i18n.global.t('device.addDeviceDrawer.unicast'),
    },
    {
      value: '02',
      label: i18n.global.t('device.addDeviceDrawer.sync'),
    },
  ],
  vbTransMethodOptions: [
    {
      value: '00',
      label: i18n.global.t('device.addDeviceDrawer.broadcast'),
    },
    {
      value: '02',
      label: i18n.global.t('device.addDeviceDrawer.sync'),
    },
  ],
  vsnTransMethodOptions: [
    {
      value: '00',
      label: i18n.global.t('device.addDeviceDrawer.broadcast'),
    },
  ],
  transTimingOptions: [
    {
      value: '00',
      label: i18n.global.t('device.addDeviceDrawer.event'),
    },
    {
      value: '01',
      label: i18n.global.t('device.addDeviceDrawer.periodic'),
    },
    {
      value: '02',
      label: i18n.global.t('device.addDeviceDrawer.eventAndPeriodic'),
    },
  ],
  edgeOptions: [
    {
      value: '00',
      label: i18n.global.t('device.addDeviceDrawer.highToLow'),
    },
    {
      value: '01',
      label: i18n.global.t('device.addDeviceDrawer.lowToHigh'),
    },
    {
      value: '02',
      label: i18n.global.t('device.addDeviceDrawer.both'),
    },
  ],
  ism900FrequencyConfigOptions: [
    /*
    { value: '00', label: i18n.global.t('device.addDeviceDrawer.all') },
    { value: '24', label: '920.6MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '25', label: '920.8MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '26', label: '921.0MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '27', label: '921.2MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '28', label: '921.4MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '29', label: '921.6MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '30', label: '921.8MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '31', label: '922.0MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '32', label: '922.2MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '33', label: '922.4MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '34', label: '922.6MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '35', label: '922.8MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '36', label: '923.0MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '37', label: '923.2MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '38', label: '923.4MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '39', label: '923.6MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '40', label: '923.8MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '41', label: '924.0MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '42', label: '924.2MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '43', label: '924.4MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '44', label: '924.6MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '45', label: '924.8MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '46', label: '925.0MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '47', label: '925.2MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '48', label: '925.4MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '49', label: '925.6MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '50', label: '925.8MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '51', label: '926.0MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '52', label: '926.2MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '53', label: '926.4MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '54', label: '926.6MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '55', label: '926.8MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '56', label: '927.0MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '57', label: '927.2MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '58', label: '927.4MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '59', label: '927.6MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '60', label: '927.8MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '61', label: '928.0MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    */
    { value: '00', label: i18n.global.t('device.addDeviceDrawer.all') },
    { value: '920.6', label: '920.6MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '920.8', label: '920.8MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '921.0', label: '921.0MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '921.2', label: '921.2MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '921.4', label: '921.4MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '921.6', label: '921.6MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '921.8', label: '921.8MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '922.0', label: '922.0MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '922.2', label: '922.2MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '922.4', label: '922.4MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '922.6', label: '922.6MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '922.8', label: '922.8MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '923.0', label: '923.0MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '923.2', label: '923.2MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '923.4', label: '923.4MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '923.6', label: '923.6MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '923.8', label: '923.8MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '924.0', label: '924.0MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '924.2', label: '924.2MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '924.4', label: '924.4MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '924.6', label: '924.6MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '924.8', label: '924.8MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '925.0', label: '925.0MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '925.2', label: '925.2MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '925.4', label: '925.4MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '925.6', label: '925.6MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '925.8', label: '925.8MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '926.0', label: '926.0MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '926.2', label: '926.2MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '926.4', label: '926.4MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '926.6', label: '926.6MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '926.8', label: '926.8MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '927.0', label: '927.0MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '927.2', label: '927.2MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '927.4', label: '927.4MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '927.6', label: '927.6MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '927.8', label: '927.8MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '928.0', label: '928.0MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
  ],
  w2_4gFrequencyConfigOptions: [
    /*
    { value: '00', label: i18n.global.t('device.addDeviceDrawer.all') },
    { value: '01', label: '2412MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '02', label: '2417MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '03', label: '2422MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '04', label: '2427MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '05', label: '2432MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '06', label: '2437MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '07', label: '2442MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '08', label: '2447MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '09', label: '2452MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '10', label: '2457MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '11', label: '2462MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '12', label: '2467MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '13', label: '2472MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '14', label: '2484MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    */
    { value: '00', label: i18n.global.t('device.addDeviceDrawer.all') },
    { value: '2412', label: '2412MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '2417', label: '2417MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '2422', label: '2422MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '2427', label: '2427MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '2432', label: '2432MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '2437', label: '2437MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '2442', label: '2442MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '2447', label: '2447MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '2452', label: '2452MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '2457', label: '2457MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '2462', label: '2462MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '2467', label: '2467MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '2472', label: '2472MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '2484', label: '2484MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
  ],
  l5gFrequencyConfigOptions: [
    /*
    { value: '00', label: i18n.global.t('device.addDeviceDrawer.all') },
    { value: '01', label: '4625MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '02', label: '4675MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '03', label: '4725MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '04', label: '4775MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '05', label: '4825MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '06', label: '4875MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    */
    { value: '00', label: i18n.global.t('device.addDeviceDrawer.all') },
    { value: '4625', label: '4625MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '4675', label: '4675MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '4725', label: '4725MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '4775', label: '4775MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '4825', label: '4825MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '4875', label: '4875MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
  ],
  w5gFrequencyConfigOptions: [
    /*
    { value: '000', label: i18n.global.t('device.addDeviceDrawer.all') },
    { value: '001', label: '4920MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '002', label: '4940MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '003', label: '4960MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '004', label: '4980MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '036', label: '5180MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '040', label: '5200MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '044', label: '5220MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '048', label: '5240MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '052', label: '5260MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '056', label: '5280MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '060', label: '5300MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '064', label: '5320MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '100', label: '5500MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '104', label: '5520MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '108', label: '5540MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '112', label: '5560MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '116', label: '5580MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '120', label: '5600MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '124', label: '5620MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '128', label: '5640MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '132', label: '5660MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '136', label: '5680MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '140', label: '5700MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '144', label: '5720MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    */
    { value: '00', label: i18n.global.t('device.addDeviceDrawer.all') },
    { value: '4920', label: '4920MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '4940', label: '4940MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '4960', label: '4960MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '4980', label: '4980MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5180', label: '5180MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5200', label: '5200MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5220', label: '5220MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5240', label: '5240MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5260', label: '5260MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5280', label: '5280MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5300', label: '5300MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5320', label: '5320MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5500', label: '5500MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5520', label: '5520MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5540', label: '5540MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5560', label: '5560MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5580', label: '5580MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5600', label: '5600MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5620', label: '5620MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5640', label: '5640MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5660', label: '5660MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5680', label: '5680MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5700', label: '5700MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
    { value: '5720', label: '5720MHz' + ' ' + i18n.global.t('device.addDeviceDrawer.only') },
  ],
};

export const allFreqRange = {
  ism900: {
    start_freq: '920.6',
    end_freq: '928.0',
  },
  w2_4g: {
    start_freq: '2412',
    end_freq: '2484',
  },
  l5g: {
    start_freq: '4625',
    end_freq: '4875',
  },
  w5g: {
    start_freq: '4920',
    end_freq: '5720',
  },
};

export const allFreqCfg = '00';

export const channelOptions = [
  // {
  //   value: '28',
  //   label: '0x28 (923.9MHz)',
  // },
  // {
  //   value: '29',
  //   label: '0x29 (924.1MHz)',
  // },
  // {
  //   value: '2A',
  //   label: '0x2A (924.3MHz)',
  // },
  // {
  //   value: '2B',
  //   label: '0x2B (924.5MHz)',
  // },
  // {
  //   value: '2C',
  //   label: '0x2C (924.7MHz)',
  // },
  // {
  //   value: '2D',
  //   label: '0x2D (924.9MHz)',
  // },
  // {
  //   value: '2E',
  //   label: '0x2E (925.1MHz)',
  // },
  // {
  //   value: '2F',
  //   label: '0x2F (925.3MHz)',
  // },
  // {
  //   value: '30',
  //   label: '0x30 (925.5MHz)',
  // },
  // {
  //   value: '31',
  //   label: '0x31 (925.7MHz)',
  // },
  // {
  //   value: '32',
  //   label: '0x32 (925.9MHz)',
  // },
  // {
  //   value: '33',
  //   label: '0x33 (926.1MHz)',
  // },
  // {
  //   value: '34',
  //   label: '0x34 (926.3MHz)',
  // },
  // {
  //   value: '35',
  //   label: '0x35 (926.5MHz)',
  // },
  // {
  //   value: '36',
  //   label: '0x36 (926.7MHz)',
  // },
  // {
  //   value: '37',
  //   label: '0x37 (926.9MHz)',
  // },
  {
    value: '28',
    label: '28',
  },
  {
    value: '29',
    label: '29',
  },
  {
    value: '2A',
    label: '2A',
  },
  {
    value: '2B',
    label: '2B',
  },
  {
    value: '2C',
    label: '2C',
  },
  {
    value: '2D',
    label: '2D',
  },
  {
    value: '2E',
    label: '2E',
  },
  {
    value: '2F',
    label: '2F',
  },
  {
    value: '30',
    label: '30',
  },
  {
    value: '31',
    label: '31',
  },
  {
    value: '32',
    label: '32',
  },
  {
    value: '33',
    label: '33',
  },
  {
    value: '34',
    label: '34',
  },
  {
    value: '35',
    label: '35',
  },
  {
    value: '36',
    label: '36',
  },
  {
    value: '37',
    label: '37',
  },
];

export const tableInitCols = [
  ...Array.from(Array(3), (_, index) => {
    return {
      key: columnType.group + (index + 1),
      label: i18n.global.t('device.group' + (index + 1)),
    };
  }),
  {
    key: columnType.unitId,
    label: i18n.global.t('device.unitId'),
  },
  {
    key: columnType.networkId,
    label: i18n.global.t('device.networkId'),
  },
  {
    key: columnType.serialNo,
    label: i18n.global.t('device.serialNo'),
  },
  {
    key: columnType.icon,
    label: i18n.global.t('device.icon'),
  },
  {
    key: columnType.typeName,
    label: i18n.global.t('device.typeName'),
  },
  {
    key: columnType.name,
    label: i18n.global.t('device.name'),
  },
  {
    key: columnType.wirelessSetting,
    label: i18n.global.t('device.wirelessSetting'),
  },
  {
    key: columnType.fwVer,
    label: i18n.global.t('device.fwVer'),
  },
  {
    key: columnType.battery,
    label: i18n.global.t('device.battery'),
  },
  {
    key: columnType.devStatus,
    label: i18n.global.t('device.devStatus'),
  },
  {
    key: columnType.rssi,
    label: i18n.global.t('device.rssi'),
  },
  {
    key: columnType.elpasedTime,
    label: i18n.global.t('device.elpasedTime'),
  },
  {
    key: columnType.receiveTime,
    label: i18n.global.t('device.receiveTime'),
  },
  {
    key: columnType.joinTime,
    label: i18n.global.t('device.joinTime'),
  },
  {
    key: columnType.autoConfig,
    label: i18n.global.t('device.autoConfig'),
  },
  {
    key: columnType.route,
    label: i18n.global.t('device.route'),
  },
  {
    key: columnType.autoConfigSchedule,
    label: i18n.global.t('device.autoConfigSchedule'),
  },
  {
    key: columnType.lastUpdateTime,
    label: i18n.global.t('device.lastUpdateTime'),
  },
  {
    key: columnType.measCycle,
    label: i18n.global.t('device.measCycle'),
  },
  {
    key: columnType.transCycle,
    label: i18n.global.t('device.transCycle'),
  },
  {
    key: columnType.transMethod,
    label: i18n.global.t('device.transMethod'),
  },
  {
    key: columnType.rssiTime,
    label: i18n.global.t('device.rssiTime'),
  },
  {
    key: columnType.otherSetting,
    label: i18n.global.t('device.otherSetting'),
  },
  ...Array.from(Array(15), (_, index) => {
    return {
      key: columnType.data + (index + 1),
      label: i18n.global.t('device.data') + (index + 1),
    };
  }),
];

export const gatewayTableInitCols = [
  {
    key: gatewayColumnType.name,
    label: i18n.global.t('gateway.name'),
  },
  {
    key: gatewayColumnType.gatewayId,
    label: i18n.global.t('gateway.gatewayId'),
  },
  // {
  //   key: gatewayColumnType.areaId,
  //   label: i18n.global.t('gateway.areaId'),
  // },
  // {
  //   key: gatewayColumnType.devType,
  //   label: i18n.global.t('gateway.devType'),
  // },
  {
    key: gatewayColumnType.fwVer,
    label: i18n.global.t('gateway.fwVer'),
  },
  {
    key: gatewayColumnType.simInfo,
    label: i18n.global.t('gateway.simInfo'),
  },
  // {
  //   key: gatewayColumnType.icon,
  //   label: i18n.global.t('gateway.icon'),
  // },
  {
    key: gatewayColumnType.parentId,
    label: i18n.global.t('gateway.parentId'),
  },
  {
    key: gatewayColumnType.portNo,
    label: i18n.global.t('gateway.portNo'),
  },
  {
    key: gatewayColumnType.panId,
    label: i18n.global.t('gateway.panId'),
  },
  {
    key: gatewayColumnType.channelNo,
    label: i18n.global.t('gateway.channelNo'),
  },
  {
    key: gatewayColumnType.isEncryption,
    label: i18n.global.t('gateway.isEncryption'),
  },
  {
    key: gatewayColumnType.macAddress,
    label: i18n.global.t('gateway.macAddress'),
  },
  {
    key: gatewayColumnType.status,
    label: i18n.global.t('gateway.status'),
  },
  // {
  //   key: gatewayColumnType.elpasedTime,
  //   label: i18n.global.t('gateway.elpasedTime'),
  // },
  {
    key: gatewayColumnType.lastDateTime,
    label: i18n.global.t('gateway.lastDateTime'),
  },
  {
    key: gatewayColumnType.deviceList,
    label: i18n.global.t('gateway.deviceList'),
  },
  {
    key: gatewayColumnType.addDevice,
    label: i18n.global.t('gateway.addDevice'),
  },
  {
    key: gatewayColumnType.userRole,
    label: i18n.global.t('gateway.userRole'),
  },
];

export const tableInitColCfg = [
  ...Array.from(Array(3), (_, index) => {
    return {
      key: columnType.group + (index + 1),
    };
  }),
  {
    key: columnType.unitId,
  },
  {
    key: columnType.networkId,
  },
  {
    key: columnType.name,
  },
  {
    key: columnType.rssi,
  },
  {
    key: columnType.route,
  },
  {
    key: columnType.elpasedTime,
  },
  {
    key: columnType.receiveTime,
  },
  {
    key: columnType.battery,
  },
  // {
  //   key: columnType.data + 1,
  // },
  {
    key: columnType.typeName,
  },
];

/*
export const tableInitColCfg = [
  ...Array.from(Array(3), (_, index) => {
    return {
      key: columnType.group + (index + 1),
    };
  }),
  {
    key: columnType.unitId,
  },
  {
    key: columnType.networkId,
  },
  {
    key: columnType.name,
  },
  {
    key: columnType.rssi,
  },
  {
    key: columnType.route,
  },
  {
    key: columnType.elpasedTime,
  },
  {
    key: columnType.receiveTime,
  },
  {
    key: columnType.battery,
  },
  {
    key: columnType.icon,
  },
  {
    key: columnType.typeName,
  },
  {
    key: columnType.name,
  },
  {
    key: columnType.wirelessSetting,
  },
  {
    key: columnType.fwVer,
  },
  {
    key: columnType.devStatus,
  },
  {
    key: columnType.joinTime,
  },
  {
    key: columnType.autoConfig,
  },
  {
    key: columnType.autoConfigSchedule,
  },
  {
    key: columnType.lastUpdateTime,
  },
  {
    key: columnType.measCycle,
  },
  {
    key: columnType.transCycle,
  },
  {
    key: columnType.transMethod,
  },
  {
    key: columnType.rssiTime,
  },
  {
    key: columnType.otherSetting,
  },
];
*/

export const gatewayTableInitColCfg = [
  {
    key: gatewayColumnType.name,
  },
  {
    key: gatewayColumnType.gatewayId,
  },
  // {
  //   key: gatewayColumnType.areaId,
  // },
  // {
  //   key: gatewayColumnType.devType,
  // },
  // {
  //   key: gatewayColumnType.fwVer,
  // },
  // {
  //   key: gatewayColumnType.simInfo,
  // },
  {
    key: gatewayColumnType.parentId,
  },
  {
    key: gatewayColumnType.portNo,
  },
  {
    key: gatewayColumnType.panId,
  },
  {
    key: gatewayColumnType.channelNo,
  },
  {
    key: gatewayColumnType.isEncryption,
  },
  {
    key: gatewayColumnType.macAddress,
  },
  {
    key: gatewayColumnType.status,
  },
  {
    key: gatewayColumnType.deviceList,
  },
  {
    key: gatewayColumnType.addDevice,
  },
  // {
  //   key: gatewayColumnType.userRole,
  // },
];

/*
export const gatewayTableInitColCfg = [
  {
    key: gatewayColumnType.name,
  },
  {
    key: gatewayColumnType.gatewayId,
  },
  // {
  //   key: gatewayColumnType.areaId,
  // },
  // {
  //   key: gatewayColumnType.devType,
  // },
  // {
  //   key: gatewayColumnType.fwVer,
  // },
  // {
  //   key: gatewayColumnType.simInfo,
  // },
  {
    key: gatewayColumnType.parentId,
  },
  {
    key: gatewayColumnType.portNo,
  },
  {
    key: gatewayColumnType.panId,
  },
  {
    key: gatewayColumnType.channelNo,
  },
  {
    key: gatewayColumnType.isEncryption,
  },
  {
    key: gatewayColumnType.macAddress,
  },
  {
    key: gatewayColumnType.status,
  },
  {
    key: gatewayColumnType.deviceList,
  },
  {
    key: gatewayColumnType.addDevice,
  },
  {
    key: gatewayColumnType.fwVer,
  },
  {
    key: gatewayColumnType.simInfo,
  },
  {
    key: gatewayColumnType.lastDateTime,
  },
];
*/

export const tableInitColWidth = {
  [columnType.group + '1']: 125,
  [columnType.group + '2']: 125,
  [columnType.group + '3']: 125,
  [columnType.unitId]: 145,
  [columnType.networkId]: 155,
  [columnType.serialNo]: 145,
  [columnType.autoConfigSchedule]: 220,
  [columnType.wirelessSetting]: 120,
  [columnType.fwVer]: 100,
  [columnType.icon]: 100,
  [columnType.typeName]: 150,
  [columnType.name]: 115,
  [columnType.battery]: 110,
  [columnType.devStatus]: 110,
  [columnType.rssi]: 120,
  [columnType.elpasedTime]: 140,
  [columnType.receiveTime]: 165,
  [columnType.joinTime]: 160,
  [columnType.autoConfig]: 100,
  [columnType.lastUpdateTime]: 180,
  [columnType.measCycle]: 170,
  [columnType.transCycle]: 100,
  [columnType.transMethod]: 150,
  [columnType.rssiTime]: 150,
  [columnType.otherSetting]: 100,
  [columnType.route]: 255,
  [columnType.data + '1']: 90,
  [columnType.data + '2']: 90,
  [columnType.data + '3']: 90,
  [columnType.data + '4']: 90,
  [columnType.data + '5']: 90,
  [columnType.data + '6']: 90,
  [columnType.data + '7']: 90,
  [columnType.data + '8']: 90,
  [columnType.data + '9']: 90,
  [columnType.data + '10']: 90,
  [columnType.data + '11']: 90,
  [columnType.data + '12']: 90,
  [columnType.data + '13']: 90,
  [columnType.data + '14']: 90,
  [columnType.data + '15']: 90,
};

export const gatewayTableInitColWidth = {
  [gatewayColumnType.gatewayId]: 145,
  [gatewayColumnType.areaId]: 80,
  [gatewayColumnType.areaLabel]: 120,
  // [gatewayColumnType.devType]: 150,
  [gatewayColumnType.fwVer]: 130,
  [gatewayColumnType.simInfo]: 170,
  [gatewayColumnType.name]: 160,
  // [gatewayColumnType.icon]: 100,
  [gatewayColumnType.parentId]: 100,
  [gatewayColumnType.portNo]: 90,
  [gatewayColumnType.panId]: 90,
  [gatewayColumnType.channelNo]: 110,
  [gatewayColumnType.isEncryption]: 110,
  [gatewayColumnType.macAddress]: 185,
  [gatewayColumnType.status]: 115,
  // [gatewayColumnType.elpasedTime]: 130,
  [gatewayColumnType.lastDateTime]: 220,
  [gatewayColumnType.deviceList]: 120,
  [gatewayColumnType.addDevice]: 100,
  [gatewayColumnType.userRole]: 110,
};

export const deviceTopicDatatypes = ['deviceInfo', 'route', 'ism900', 'w2_4g', 'l5g', 'w5g'];

export const topicType = {
  gatewayResponse: 'gatewayResponse',
  gatewayRequest: 'gatewayRequest',
  gatewayStatusChecked: 'gatewayStatusChecked',
  gatewayStatusChange: 'gatewayStatusChange',
  deviceData: 'deviceData',
  keepAlive: 'keepAlive',
  dummy: 'dummy',
  areaDeleted: 'areaDeleted',
  userDeleted: 'userDeleted',
  adminChanged: 'adminChanged',
};

export const defaultAreaWords = [
  i18n.global.t('area.default', {}, { locale: 'ja' }),
  i18n.global.t('area.default', {}, { locale: 'en' }),
];

export const serviceId = {
  basic: '0',
  radioWaveMonitoring: '1',
  dashboard: '2',
  maintenance: '3',
};

export const subscriptionStatus = {
  before: 0,
  start: 1,
  suspension: 2,
  termination: 3,
};

export const subscriptionStatusName = {
  0: 'before',
  1: 'start',
  2: 'suspension',
  3: 'cancel',
};

export const subscriptionEventsType = {
  START: 'START',
  SUSPENSION: 'SUSPENSION',
  CANCEL: 'CANCEL',
};

export const thingNamePrefix = 'RWM-Gateway-';

export const contactAddress = 'dempa-viewer.support@murata.com';

export const DBL_CLICK_THRESHHOLD = 300;

export const DB_UPDATE_TIMEOUT = 500;

export const CHECKBOX_PIXEL = 55;

export const GATEWAY_PER_AREA_LIMIT = 10 * 2;

export const DEVICE_PER_GATEWAY_LIMIT = 100 * 2;

export const gatewayNetworkId = '7FFF';

export const initialSubGCfgKey = '12345678123456781234567812345678'; // '00000000000000000000000000000001'

export const wsnInfoUrl = 'https://example.com';

export const rwmInfoUrl = 'https://example.com';

export const radioWaveMonitoringUrl = 'https://dashboard.dempa-viewer.com/';

export const sensorManagerUrl = 'https://sensor-manager.wsn-cloud-service.com/';

export const sensorManagerObjKey = 'sensor-manager.pdf';

export const radioWaveMonitoringObjKey = 'dempa-viewer.pdf';

export const MIN_DEVLIST_REFRESH_CYCLE = 2000;

// FEデバイス バージョン閾値
export const FE_VERSION_THRESHOLDS = {
  '1AR': {
    frequencyConfigSupport: 698, // このバージョン以上で送信周期設定対応
  },
  '2CT': {
    solarModeSupport: 656, // このバージョン以上でソーラー電源運用モード対応
    frequencyConfigSupport: 656, // このバージョン以上で送信周期設定対応
  },
};
